export default "__VITE_ASSET__BIOwI4Lm__"